import { Map as NewbuildingMapComponent } from '@cian/frontend-newbuilding-map-component';
import { useCallback } from 'react';

import { IInfrastructureData, ITAInfrastructureData, TTAInfrastructureType } from '../../../types/map';
import { toGeoObjects, toTransportAccessibilityGeoObjects } from '../utils/mappers';

interface IUseSetGeoObjectsCallbacksResult {
  /**
   * Устанавливает геообъекты обычной инфраструктуры по типам и году.
   */
  setRegularGeoObjects: (currentTypes: string[], selectedYear: number, isMapServicesVisible: boolean) => void;
  /**
   * Устанавливает геообъекты сервиса транспортной доступности по типу.
   */
  setTransportAccessibilityGeoObjects: (infrastructureType: TTAInfrastructureType | null) => void;
}

/**
 * Возвращает функции установки геообъектов на карту.
 */
export const useSetGeoObjectsCallbacks = (
  mapApi: NewbuildingMapComponent | null,
  regularInfrastructureByYear: Map<number, IInfrastructureData>,
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
  currentTypes: string[],
  selectedYear: number,
  resetTARouting: () => void,
): IUseSetGeoObjectsCallbacksResult => {
  const setRegularGeoObjects = useCallback(
    (currentTypes: string[], selectedYear: number, onlyExisting: boolean) => {
      const geoObjects = toGeoObjects(regularInfrastructureByYear, selectedYear, onlyExisting);
      const geoObjectsByType = geoObjects.filter(item => currentTypes.includes(item.name));

      mapApi?.removeAllGeoObjects();
      mapApi?.addGeoObjects(geoObjectsByType);
    },
    [mapApi, regularInfrastructureByYear],
  );

  const setTransportAccessibilityGeoObjects = useCallback(
    (infrastructureType: TTAInfrastructureType | null) => {
      if (infrastructureType) {
        const geoObjects = toTransportAccessibilityGeoObjects(
          transportAccessibilityInfrastructureByType,
          infrastructureType,
        );

        mapApi?.removeAllGeoObjects();
        mapApi?.addGeoObjects(geoObjects);
      } else {
        setRegularGeoObjects(currentTypes, selectedYear, true);
      }

      resetTARouting();
    },
    [
      mapApi,
      transportAccessibilityInfrastructureByType,
      currentTypes,
      selectedYear,
      setRegularGeoObjects,
      resetTARouting,
    ],
  );

  return {
    setRegularGeoObjects,
    setTransportAccessibilityGeoObjects,
  };
};
